import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { IVolunteerFilter, useVolunteerSummaryQuery } from '../../../../queries/Volunteer';
import { Skeleton } from '../../../components-v2/Skeleton';
import {
	DataboardStat,
	DataboardStatLabel,
	DataboardStats,
	DataboardStatTitle,
	DataboardStatValue,
} from '../../../components/Databoard';
import { formatCurrency } from '../../AdvancedReporting/helpers/formatCurrency';
import { formatVolunteerHours as formatHours } from '../../../components/volunteering/DonatedTimeValueHelp';
import { styleSheet } from './styles';

const formatPercent = (value: number) => `${(value * 100).toFixed(1)}%`;

interface IProps {
	filter?: IVolunteerFilter;
	impersonationContext?: Api.IImpersonationContext;
}

export const VolunteerSummaryStats = ({ filter, impersonationContext }: IProps) => {
	const { data, isLoading, isError } = useVolunteerSummaryQuery({ filter, impersonationContext });
	const ratePerHour = data?.donatedTimeValueRatePerHour;

	const stat = (label: string, value: string | number, isTotal?: boolean, caption?: string) => (
		<DataboardStat>
			<DataboardStatLabel>{label}</DataboardStatLabel>
			{isLoading ? (
				<Skeleton styles={[styleSheet.statSkeleton]} />
			) : (
				<>
					<DataboardStatValue isTotal={isTotal}>{isError ? '—' : value}</DataboardStatValue>
					{caption ? <span className={css(styleSheet.statCaption)}>{caption}</span> : null}
				</>
			)}
		</DataboardStat>
	);

	return (
		<DataboardStats>
			<DataboardStatTitle>Volunteer Stats</DataboardStatTitle>
			{stat('Total hours', formatHours(data?.totalHours ?? 0))}
			{stat('Volunteers', data?.totalVolunteers ?? 0)}
			{stat('Participations', data?.participationCount ?? 0)}
			{stat('No-show rate', formatPercent(data?.noShowRate ?? 0))}
			{stat('Avg hours per volunteer', formatHours(data?.averageHoursPerVolunteer ?? 0))}
			{stat(
				'Donated time value',
				formatCurrency(data?.donatedTimeValue ?? 0),
				true,
				ratePerHour ? `Independent Sector rate: ${formatCurrency(ratePerHour)} per hour` : undefined
			)}
		</DataboardStats>
	);
};
